module.exports = __webpack_public_path__ + "static/img/lianmeng1.dee9212.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xieyi/lianmeng1.jpg
// module id = 1416
// module chunks = 1